import Vue from "vue";
import Vuex from "vuex";
import router from "../router";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: null,
    loggingIn: false,
    loginError: null,
    regionId: null,
    pathName: "",
    navCurrentIndex: "1",
    collaborators: [],
    costCenters: [],
    menuIsDisable: false,
    rulesMonth: null,
    navItems: [
      {
        index: "1",
        disabled: false,
        vText: "Rateios",
        route: "/",
      },
      {
        index: "2",
        disabled: false,
        vText: "Projetos",
        route: "/costcenters",
      },
      {
        index: "3",
        disabled: false,
        vText: "Colaboradores",
        route: "/collaborators",
      },
      {
        index: "4",
        disabled: false,
        vText: "Usuários",
        route: "/users",
      },
      {
        index: "5",
        disabled: false,
        vText: "Áreas",
        route: "/areas",
      },
      {
        index: "6",
        disabled: false,
        vText: "Regras de rateio",
        route: "/rules",
      },
    ],
  },
  mutations: {
    loginStart: (state) => (state.loggingIn = true),
    loginStop: (state, errorMessage) => {
      state.loggingIn = false;
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    logout: (state) => {
      state.accessToken = null;
    },
    updateNavItems: (state, path) => {
      state.navItems = path;
    },
    updateRegionId: (state, id) => {
      state.regionId = id;
    },
    updateNavCurrentIndex: (state, index) => {
      state.navCurrentIndex = index;
    },
    updateCollaborators: (state, collaborators) => {
      state.collaborators = collaborators;
    },
    updateCostCenters: (state, costCenters) => {
      state.costCenters = costCenters;
    },
    updateMenuIsDisable: (state, value) => {
      state.menuIsDisable = value;
    },
    updateRulesMonth: (state, value) => {
      state.rulesMonth = value;
    }
  },
  actions: {
    updateNavCurrentIndex({ commit }, index) {
      commit("updateNavCurrentIndex", index);
    },
    updateNavItems({ commit }, path) {
      commit("updateNavItems", path);
    },
    updateRegionId({ commit }, id) {
      localStorage.setItem("regionId", id);
      commit("updateRegionId", id);
    },
    doLogin({ commit }, loginData) {
      commit("loginStart");
      localStorage.setItem("accessToken", loginData.tokenId);
      localStorage.setItem("accessUserName", loginData.userName);
      commit("loginStop", null);
      commit("updateAccessToken", loginData.tokenId);
      router.push("/");
    },
    fetchAccessToken({ commit }) {
      commit("updateAccessToken", localStorage.getItem("accessToken"));
    },
    logout({ commit }) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("regionId");
      localStorage.removeItem("accessUserName");
      sessionStorage.removeItem("costCenters");
      sessionStorage.removeItem("collaborators");
      commit("logout");
      router.go('/login')
    },
    notify({ title = "Titulo", message = "Mensagem", type = "warning" }) {
      if (process.env.VUE_APP_NOTIFICATIONS === "true") {
        ElementUI.Notification({
          title: title,
          message: message,
          type: type,
          duration: 0,
          position: "bottom-right",
        });
      }
    },
    async updateCollaborators({ commit }, collaborators) {
      sessionStorage.setItem("collaborators", JSON.stringify(collaborators));
      commit("updateCollaborators", collaborators);
    },
    async updateCostCenters({ commit }, costCenters) {
      sessionStorage.setItem("costCenters", JSON.stringify(costCenters));
      commit("updateCostCenters", costCenters);
    },
    setMenuIsDisableState({ commit }, state) {
      commit("updateMenuIsDisable", state);
    },
    setRulesMonth({ commit }, value) {
      sessionStorage.setItem("rulesMonth", new Date(value).toISOString());
      commit("updateRulesMonth", value)
    }
  },
  getters: {
    getCollaborators(state) {
      return state.collaborators.length === 0
        ? JSON.parse(sessionStorage.getItem("collaborators"))
        : state.collaborators;
    },
    getCostCenters(state) {
      return state.costCenters.length === 0
        ? JSON.parse(sessionStorage.getItem("costCenters"))
        : state.costCenters;
    },
    getAccesToken(state) {
      return state.accessToken;
    },
    getLocationId(state) {
      return state.regionId || localStorage.getItem('regionId');
    },
    getRulesMonth(state) {
      return state.rulesMonth || sessionStorage.getItem('rulesMonth') || new Date()
    },
    formatterNumber: () => (num, places = 2) => {
      if (!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + places) + "e-" + places);
      } else {
        let arr = ("" + num).split("e");
        let sig = "";
        if (+arr[1] + places > 0) {
          sig = "+";
        }

        return +(
          Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) +
          "e-" +
          places
        );
      }
    },
    getMenuIsDisable(state) {
      return state.menuIsDisable;
    }
  }
})
